import axios from 'axios';
import get from 'lodash/get';

// Libs
import { thunkHandler, thunkErrorHanlder, parseUrl} from '../../libs/utils';


// Constants
import { INVOICE_SINGLE_COLLECTION, COLLECTION_BASE, COLLECTION_SINGLE, TEAM } from '../../constants/endpoints';

export const NEW_COLLECTION_STEPS   = 'NEW_COLLECTION_STEPS';
export const SEND_COLLECTION_NOTICE = 'SEND_COLLECTION_NOTICE';
export const NEW_TEAM_DATA          = 'NEW_TEAM_DATA';
export const NEW_TEAM_EMAILS        = 'NEW_TEAM_EMAILS';



/*
  === Global settings
*/
export function getCollectionSettings() {
  return dispatch  => axios.get(COLLECTION_BASE)
    .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_COLLECTION_STEPS, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END getCollectionSettings

// ::TODO:: Finish collection global switch
export function toggleGlobalCollectionStatus() {
  return dispatch  => axios.post(COLLECTION_BASE)
    .then(res => thunkHandler(dispatch, get(res, 'data.data', 1), NEW_COLLECTION_STEPS, 'ERROR'))
    // .then(data => dispatch(showNormalNotification({
    //   message: 'Estado cambiado',
    //   color: 'primary'

    // })))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END toggleGlobalCollectionStatus


export function changeCollectionStep(uuid, newState) {
  return dispatch  => axios.put(parseUrl(COLLECTION_SINGLE, { uuid }), newState)
    .then(() => axios.get(COLLECTION_BASE))
    // .then(data => dispatch(showNormalNotification({
    //   message: 'Paso actualizado',
    //   color: 'primary'

    // })))
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_COLLECTION_STEPS, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END changeCollectionStep


export function addCollectionStep(state) {
  return dispatch  => axios.post(COLLECTION_BASE, state)
    .then(() => axios.get(COLLECTION_BASE))
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_COLLECTION_STEPS, 'ERROR'))
    // .then(data => dispatch(showNormalNotification({
    //     message: 'Paso creado',
    //     color: 'primary'

    // })))
    .catch(error => {
      thunkErrorHanlder(error, dispatch, 'ERROR');
      throw error;
    });

} // END addCollectionStep


export function deleteCollectionStep(uuid) {
  return dispatch  => axios.delete(parseUrl(COLLECTION_SINGLE, { uuid }))
    .then(() => axios.get(COLLECTION_BASE))
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_COLLECTION_STEPS, 'ERROR'))
    // .then(data => dispatch(showNormalNotification({
    //   message: 'Paso eliminado',
    //   color: 'success'

    // })))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END deleteCollectionStep



/*
  === Settings
*/
export function toggleCollectionStatus(status) {
  const value = parseInt(status) === 1 ? 0 : 1;
  return dispatch => axios.put(TEAM, { invoice_collection_enabled: value })
    // .then(data => dispatch(showNormalNotification({ message })))
    .catch((error) => dispatch({ type: "ERROR", payload: error }));

} // END toggleCollectionStatus



/*
  === Invoice related
*/
export function getSingleInvoiceCollection(uuid) {
  return () => {
    return axios.get(parseUrl(INVOICE_SINGLE_COLLECTION, { uuid }))
      .then(res => get(res, 'data.data'));

  } // END return

} // END getSingleInvoiceCollection



// WEBPACK FOOTER //
// ./src/redux/actions/collectionActions.js